<template>
  <div :class="['radio-main', disabled ? 'disabled' : '', line === 'one' ? 'line' : line === 'more' ? 'more' : '']">
    <div
      v-for="(item, index) in list"
      :key="index"
      :class="['menu', item.value === select ? 'action' : '', {'disabled-menu': item.value === 'time' && hasWorkSubItem}]"
      @click="item.value === 'time' && hasWorkSubItem ? null : selectOption(item.value)">
      <div class="menu-select"></div>
      <div class="menu-content" v-html="item.content"></div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'radio',
  props: {
    value: '',
    line: {
      type: String,
      default: 'two'
    },
    list: {
      type: Array
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      select: ''
    };
  },
  computed: {
    ...mapState('editor', ['hasWorkSubItem'])
  },
  watch: {
    hasWorkSubItem(val) {
      console.log(val,"===============>hasWorkSubItem============")
    },
    value: {
      keep: true,
      immediate: true,
      handler: function (val) {
        this.select = val;
      }
    },
    select: {
      keep: true,
      immediate: true,
      handler: function (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    selectOption(value) {
      this._value = value;
      this.$emit('input', value);
      this.$emit('change', value)
    }
  }
}
</script>
<style lang="scss" scoped>
  .radio-main {
    width: 100%;
    .menu {
      width: 100%;
      display: flex;
      align-items: flex-start;
      cursor: pointer;
      flex: none;
      margin-bottom: 12px;
      &:last-child {
        margin: 0;
      }
      .menu-select {
        width: 14px;
        height: 14px;
        border-radius: 50%;
        border: 1px solid #606060;
        position: relative;
      }
      &.action .menu-select {
        border-color: #FF4F4C;
        &::after {
          content: "";
          display: block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #FF4F4C;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
        }
      }
      .menu-content {
        width: calc(100% - 34px);
        margin-left: 16px;
      }
      &.disabled-menu {
        cursor: not-allowed;
        .menu-select {
          border-color: #cfcfcf;
        }
        .menu-content {
          div {
            color: #cfcfcf!important;
          }
        }
      }
    }
    &.disabled {
      .menu {
        cursor: no-drop;
        .menu-select {
          border-color: #606060!important;
          background: #eee!important;
          &::after {
            width: 0!important;
            border: none!important;
            height: 0!important;
            background: none!important;
          }
        }
      }
    }
    &.line {
      display: flex;
      align-items: center;
      .menu {
        width: 66px;
        margin: 0;
        align-items: center;
        // flex: none;
        .menu-content {
          margin-left: 6px;
        }
      }
    }
    &.more {
      display: flex;
      flex-wrap: wrap;
      .menu{
        width: 50%;
        margin-bottom: 22px;
      }
    }
  }
</style>
